import api from "api/api";

export interface IdBasedLookup {
  id: number;
  name: string;
  description: string;
}
export async function fetchCatTools(): Promise<IdBasedLookup[]> {
  const response = await api.get<IdBasedLookup[]>("/api/lookups/cattools");
  // Convert id to string for compatibility if needed
  return response.data.map((x) => ({ id: x.id, name: x.name, description: x.description }));
}
